import type * as Y from 'yjs';

/**
 * Set an attribute on a Y.Xml value, it skips the update to avoid increasing update size.
 */
export function setYXmlPrimitive<KV extends { [key: string]: any } = { [key: string]: string }>(
    yValue: Y.XmlElement<KV> | Y.XmlText,
    prop: keyof KV & string,
    value: KV[typeof prop]
) {
    if (!yValue.doc || yValue.getAttribute(prop) !== value) {
        yValue.setAttribute(prop, value);
    }
}

/**
 * Remove an attribute on a Y.Xml value.
 */
export function removeYXmlPrimitive<KV extends { [key: string]: any } = { [key: string]: string }>(
    yValue: Y.XmlElement<KV>,
    prop: keyof KV & string
) {
    if (!yValue.doc || yValue.hasAttribute(prop)) {
        yValue.removeAttribute(prop);
    }
}
